import { render, staticRenderFns } from "./FlyerBlock.vue?vue&type=template&id=6fe1a326"
import script from "./FlyerBlock.vue?vue&type=script&lang=js"
export * from "./FlyerBlock.vue?vue&type=script&lang=js"
import style0 from "./FlyerBlock.vue?vue&type=style&index=0&id=6fe1a326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports